<div class="title">
  <p>{{ "COMMON.PROJECT_DESIGNATION.SINGLE" | translate}}</p>
  <button type="button" class="btn btn-primary" data-bs-toggle="modal" data-bs-target="#addEditProjectDesignation"
    (click)="addNew()" *ngIf="utilityId != 0 && bpsAdminLevel != 2">
    <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path fill-rule="evenodd" clip-rule="evenodd"
        d="M8 0C7.4477 0 7 0.44772 7 1V7H1C0.44772 7 0 7.4477 0 8C0 8.5523 0.44772 9 1 9H7V15C7 15.5523 7.4477 16 8 16C8.5523 16 9 15.5523 9 15V9H15C15.5523 9 16 8.5523 16 8C16 7.4477 15.5523 7 15 7H9V1C9 0.44772 8.5523 0 8 0Z"
        fill="white" />
    </svg>
    {{ "CRUD_SETTINGS.ADD_NEW" | translate }}
  </button>
</div>
<div class="container-fluid border-bottom">
  <table>
    <tr class="header-row">
      <th>{{ "COMMON.PROJECT_DESIGNATION.SINGLE" | translate | uppercase}}</th>
      <th>{{ "COMMON.PROJECT_DESIGNATION.PROJECT_TYPE" | translate | uppercase}}</th>
      <th>{{ "COMMON.PROJECT_DESIGNATION.PROJECT_PAYMENT_STATUS" | translate | uppercase}}</th>
      <th></th>
    </tr>
    <tr class="content-wrapper" *ngFor="let projectDesignation of projectDesignations" data-bs-toggle="modal" data-bs-target="#addEditProjectDesignation" (click)="selectProjectDesignation(projectDesignation)">
      <td>{{ projectDesignation.name | hasValue }}</td>
      <td>{{ projectDesignation.projectType | hasValue }}</td>
      <td>{{ projectDesignation.projectPaymentStatus | hasValue }}</td>
      <td class="td-svg">
        <svg data-bs-toggle="modal" data-bs-target="#deleteProjectDesignation" (click)="selectProjectDesignation(projectDesignation)" width="22"
          height="22" viewBox="0 0 22 22" xmlns="http://www.w3.org/2000/svg" *ngIf="bpsAdminLevel != 2">
          <path fill-rule="evenodd" clip-rule="evenodd"
            d="M11 22C17.0751 22 22 17.0751 22 11C22 4.92487 17.0751 0 11 0C4.92487 0 0 4.92487 0 11C0 17.0751 4.92487 22 11 22ZM11 20C15.9706 20 20 15.9706 20 11C20 6.02944 15.9706 2 11 2C6.02944 2 2 6.02944 2 11C2 15.9706 6.02944 20 11 20ZM6 11C6 10.4477 6.44772 10 7 10H15C15.5523 10 16 10.4477 16 11C16 11.5523 15.5523 12 15 12H7C6.44772 12 6 11.5523 6 11Z"
            fill="#DE350B" />
        </svg>
      </td>
    </tr>
  </table>
</div>
<div>
  <app-paging *ngIf="count > 0" [pageSize]="pageSize" [count]="count" [currentPage]="currentPage" (pageChange)="pageChange($event)"></app-paging>
</div>

<div class="modal fade" id="addEditProjectDesignation" tabindex="-1" aria-hidden="true" (hidden.bs.modal)="onModalFade()">
  <div class="modal-dialog modal-dialog-centered">
    <div class="modal-content">
      <div class="modal-header">
        <h5 class="modal-title" id="exampleModalLongTitle">
          {{ actionLabel$ | async }}
          {{"COMMON.PROJECT_DESIGNATION.SINGLE" | translate }}
        </h5>
        <button type="button" #closeAddEditModal class="btn-cancel-modal" data-bs-dismiss="modal">
          {{ "COMMON.CANCEL" | translate }}
        </button>
      </div>
      <form id="addForm" class="form-wrapper" ngNativeValidate (submit)="save()">
        <div class="modal-body">
          <div class="form-item form-floating mb-3">
            <input id="projectDesignationName" name="name" type="text" [(ngModel)]="selectedProjectDesignation.name" class="form-control" required placeholder=" " />
            <label for="projectDesignationName">{{ "COMMON.PROJECT_DESIGNATION.SINGLE" | translate }}</label>
          </div>
          <div class="form-item form-floating mb-3">
            <select 
              [ngClass]="selectedProjectType != undefined ? 'selected-option' : ''"
              class="form-select" 
              name="selectProjectType"
              [(ngModel)]="selectedProjectType"
            >
              <option [ngValue]="undefined" class="dropdown-item" disabled>
                {{ "COMMON.PROJECT_DESIGNATION.PROJECT_TYPE" | translate }}
              </option>
              <option 
                *ngFor="let projectType of projectTypes" 
                [ngValue]="projectType.value"
              >
                {{ projectType.label }}
              </option>
            </select>
            <label
              *ngIf="selectedProjectType != undefined"
              class="label-for-select"
              for="floatingSelect"
              >{{ "COMMON.PROJECT_DESIGNATION.PROJECT_TYPE" | translate }}</label
            >
            </div>
        </div>
        <div class="form-item form-floating mb-3">
            <select 
              [ngClass]="selectedProjectPaymentStatus != undefined ? 'selected-option' : ''"
              class="form-select" 
              name="selectProjectPatmentType"
              [(ngModel)]="selectedProjectPaymentStatus"
            >
              <option [ngValue]="undefined" class="dropdown-item" disabled>
                {{ "COMMON.PROJECT_DESIGNATION.PROJECT_PAYMENT_STATUS" | translate }}
              </option>
              <option 
                *ngFor="let projectPaymentStatus of projectPaymentStatuses" 
                [ngValue]="projectPaymentStatus.value"
              >
                {{ projectPaymentStatus.label }}
              </option>
            </select>
            <label
              *ngIf="selectedProjectPaymentStatus != undefined"
              class="label-for-select"
              for="floatingSelect"
              >{{ "COMMON.PROJECT_DESIGNATION.PROJECT_PAYMENT_STATUS" | translate }}</label
            >
        </div>
        <div class="modal-footer" *ngIf="bpsAdminLevel != 2">
          <button class="btn btn-primary" form="addForm">
            {{ "COMMON.SAVE" | translate }}
          </button>
        </div>
      </form>
    </div>
  </div>
</div>

<div class="modal fade" id="deleteProjectDesignation" tabindex="-1" aria-hidden="true">
  <div class="modal-dialog modal-dialog-centered">
    <div class="modal-content">
      <div class="modal-header delete-modal-header">
        <h5 class="modal-title" id="exampleModalLongTitle">
          {{ "CRUD_SETTINGS.ARE_YOU_SURE_DELETE" | translate }}
          {{ "COMMON.PROJECT_DESIGNATION.SINGLE" | translate }}?
        </h5>
      </div>
      <div class="modal-footer">
        <button type="button" class="btn btn-danger" (click)="deleteProjectDesignation()">
          {{ "COMMON.DELETE" | translate }}
        </button>
        <button #closeDeleteModal hidden="true" data-bs-dismiss="modal"></button>
      </div>
    </div>
  </div>
</div>
